// src/components/ui/Separator.jsx
import React from 'react';

export function Separator() {
  return <div className="separator"></div>;
}
